// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"menuText": "#3A71A8",
	"menuActiveText": "#409EFF",
	"subMenuActiveText": "#409EFF",
	"menuBg": "#fff",
	"menuHover": "#d9ecff",
	"subMenuBg": "#fff",
	"subMenuHover": "#d9ecff",
	"sideBarWidth": "210px"
};
module.exports = exports;
